import React, { useEffect } from "react";
import styles from "./style.module.css";
import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar/Navbar";
import { images } from "../../assets/images";
import { useNavigate } from "react-router-dom";

const JobDescription = () => {
  const { BackIcon, Bag, Bulb, Work, Document } = images;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const navigate = useNavigate();
  const handleClick = () => {
    // Navigate to the "/career" route
    navigate("/career");
  };
  return (
    <div>
      <Navbar text="Login Sign Up" />
      <div className={styles.container}>
        <div className={styles.back}>
          <img onClick={handleClick} src={BackIcon} alt="Back" />{" "}
          <span onClick={handleClick}>See all Positions</span>
        </div>
        <div className={styles.applyContainer}>
          <p>You're applying for:</p>
          <button
            onClick={() => navigate("/jobform")}
            id={styles.btn1}
            className={styles.btn}
          >
            Apply Now{" "}
          </button>
        </div>
        <div className={styles.overview}>
          <h5>Engineering manager</h5>
          <p>Bangluru , India</p>
          <p>24/06/2023</p>
        </div>
        <div className={styles.jobInfo}>
          <div className={styles.infoContainer}>
            <img src={Document} alt="Bag" />
            <div className={styles.textContainer}>
              <p>Contract Type:</p>
              <h5>Employee</h5>
            </div>
          </div>
          <div className={styles.infoContainer}>
            <img src={Bag} alt="Bag" />
            <div className={styles.textContainer}>
              <p>Work Type:</p>
              <h5>Full-time</h5>
            </div>
          </div>
          <div className={styles.infoContainer}>
            <img src={Bulb} alt="Bulb" />
            <div className={styles.textContainer}>
              <p>Level:</p>
              <h5>Senior</h5>
            </div>
          </div>
          <div className={styles.infoContainer}>
            <img src={Work} alt="Bag" />
            <div className={styles.textContainer}>
              <p>Payment:</p>
              <h5> &#8377; 90k-120k</h5>
            </div>
          </div>
        </div>
        <button
          onClick={() => navigate("/jobform")}
          id={styles.btn2}
          className={styles.btn}
        >
          Apply Now{" "}
        </button>
        <div className={styles.companyOvContainer}>
          <h5 className={styles.companyOv}>Company Overview</h5>
          <p>
            Lorem ipsum dolor sit amet consectetur. Cursus molestie et et diam
            sed proin. Lectus sed nam dictum duis dolor massa in cras. Sed
            consectetur nisl quis vitae. Amet tempus eu laoreet a habitant et
            scelerisque. Velit sit fusce sed facilisis amet molestie odio. Diam
            leo ultrices sed viverra non ut in diam. facilisis amet molestie
            odio. Diam leo ultrices sed viverra non ut in diam
            <br /> <br />
            Ut sed convallis nunc nullanunc urna nulla elit egestas.
            Pellentesque elementum feugiat erat volutpat integer nisi lacus
            diam. Imperdiet velit auctor massa commodo accumsan placerat. Arcu
            vestibulum adipiscing vitae amet tellus lacinia. Integer ultricies
            diam molestie risus non diam et. Convallis sapien massa lacus
            blandit nisl cursus non tortor lacus. Arcu quis a vulputate nullam
            ut rutrum arcu ultrices viverra. Inultrices lacus curabitur in
            integer adipiscing ac. facilisis amet molestie odio. Diam leo
            ultrices sed viverra non ut in diam. facilisis amet molestie odio.
            Diam leo ultrices sed viverra non ut in diam <br /> <br />
            Lorem ipsum dolor sit amet consectetur. Cursus molestie et et diam
            sed proin. Lectus sed nam dictum duis dolor massa in cras. Sed
            consectetur nisl quis vitae. Amet tempus eu laoreet a habitant et
            scelerisque. Velit sit fusce sed facilisis amet molestie odio. Diam
            leo ultrices sed viverra non ut in diam.
          </p>
        </div>
        <div className={styles.companyOvContainer}>
          <h5>Job Description</h5>
          <h6>
            Please note: This role will be based in Bengaluru, IN and requires
            an in-office presence.
          </h6>
          <p>
            Lorem ipsum dolor sit amet consectetur. Cursus molestie et et diam
            sed proin. Lectus sed nam dictum duis dolor massa in cras. Sed
            consectetur nisl quis vitae. Amet tempus eu laoreet a habitant et
            scelerisque. Velit sit fusce sed facilisis amet molestie odio. Diam
            leo ultrices sed viverra non ut in diam. facilisis amet molestie
            odio. Diam leo ultrices sed viverra non ut in diam
            <br /> <br />
            Ut sed convallis nunc nullanunc urna nulla elit egestas.
            Pellentesque elementum feugiat erat volutpat integer nisi lacus
            diam. Imperdiet velit auctor massa commodo accumsan placerat. Arcu
            vestibulum adipiscing vitae amet tellus lacinia. Integer ultricies
            diam molestie risus non diam et. Convallis sapien massa lacus
            blandit nisl cursus non tortor lacus. Arcu quis a vulputate nullam
            ut rutrum arcu ultrices viverra. Inultrices lacus curabitur in
            integer adipiscing ac. facilisis amet molestie odio. Diam leo
            ultrices sed viverra non ut in diam. facilisis amet molestie odio.
            Diam leo ultrices sed viverra non ut in diam <br /> <br />
            Lorem ipsum dolor sit amet consectetur. Cursus molestie et et diam
            sed proin. Lectus sed nam dictum duis dolor massa in cras. Sed
            consectetur nisl quis vitae. Amet tempus eu laoreet a habitant et
            scelerisque. Velit sit fusce sed facilisis amet molestie odio. Diam
            leo ultrices sed viverra non ut in diam.
          </p>
        </div>

        <div className={styles.Qualification}>
          <h5>Qualification</h5>
          <ul>
            <li>
              Lorem ipsum dolor sit amet consectetur. Cursus molestie et et diam
              sed proin. ipsum dolor sit amet consectetur. Cursus molestie et et
              diam sed proin. Lectus sed nam dictum duis dolor massa in cras.
              Sed consectetur nisl quis vitae.
            </li>
            <li>
              Ut sed convallis nunc nulla nunc urna nulla elit egestas.
              Pellentesque elementum feugiat erat volutpat integer nisi lacus
              diam. Imperdiet velit auctor massa commodo accumsan placerat. Arcu
              vestibulum adipiscing vitae amet tellus lacinia. Integer ultricies
              diam molestie risus non diam et.
            </li>
            <li>
              Lorem ipsum dolor sit amet consectetur. Cursus molestie et et diam
              sed proin. Lectus sed nam dictum duis dolor massa in cras. Sed
              consectetur nisl quis vitae.
            </li>
          </ul>
        </div>

        <div className={styles.benefits}>
          <h5>Avasift Benefits: </h5>
          <p>
            Ut sed convallis nunc nullanunc urna nulla elit egestas.
            Pellentesque elementum feugiat erat volutpat integer nisi lacus
            diam. Imperdiet velit auctor massa commodo accumsan placerat. Arcu
            vestibulum adipiscing vitae amet tellus lacinia. Integer ultricies
            diam molestie risus non diam et. Convallis sapien massa lacus
            blandit nisl cursus non tortor lacus. Arcu quis a vulputate nullam
            ut rutrum arcu ultrices viverra. Inultrices lacus curabitur in
            integer adipiscing ac. facilisis amet molestie odio. Diam leo
            ultrices sed viverra non ut in diam. facilisis amet molestie odio.
            Diam leo ultrices sed viverra non ut in diam <br /> <br />
            Lorem ipsum dolor sit amet consectetur. Cursus molestie et et diam
            sed proin. Lectus sed nam dictum duis dolor massa in cras. Sed
            consectetur nisl quis vitae. Amet tempus eu laoreet a habitant et
            scelerisque.
            <br /> <br />
          </p>
        </div>
        <div className={styles.btnContainer}>
          <button className={styles.btn} onClick={() => navigate("/jobform")}>
            I'm Interested{" "}
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default JobDescription;
